import { useQuery } from '@tanstack/react-query'
import { useRecoilValue } from 'recoil'

import { useNodeApi } from '../api-provider'
import { selectedRoleState } from '../state'

const QUERY_KEY = 'listVendiaTables'

export function useListVendiaTables(filter?: any) {
  const nodeApi = useNodeApi()
  const { urqlClient } = nodeApi

  const selectedRoleName = useRecoilValue(selectedRoleState).name

  return useQuery({
    queryKey: [QUERY_KEY, selectedRoleName],
    queryFn: async () => {
      if (!urqlClient) {
        throw new Error('Node API client is not available')
      }
      const result = await urqlClient
        .query(listVendiaTablesQuery, {
          filter: filter ? filter : undefined,
        })
        .toPromise()
      if (result?.error) {
        throw new Error(result.error?.message)
      }
      return result.data.listVendia_TableItems.Vendia_TableItems
    },
    enabled: !!selectedRoleName,
  })
}

const listVendiaTablesQuery = /* GraphQL */ `
  query listVendiaTables($filter: Vendia_Table_FilterInput_) {
    listVendia_TableItems(filter: $filter) {
      Vendia_TableItems {
        _acl {
          operations
          path
          principal {
            nodes
          }
        }
        _id
        _owner
        columns {
          comment
          fieldId
          fieldType
          identifier
          name
          required
        }
        defaultShareWith
        name
        nodeTableName
        policies {
          columnPolicies {
            effect
            name
            operator
            value
          }
          defaultColumnPolicyEffect
          rowPolicies {
            effect
            name
            operator
            value
          }
        }
        source {
          definition {
            cloudera {
              connectionId
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
            mysql {
              connectionId
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
            bigquery {
              connectionId
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
            databricks {
              connectionId
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
            postgres {
              connectionId
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
            s3 {
              connectionId
              csvColumns
              csvOptions {
                dateFormat
                delimiter
                enclosure
                errorHandling
                header
                timeFormat
                timestampFormat
                whitespace
              }
              fileName
            }
            snowflake {
              connectionId
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
            upload {
              csvColumns
              csvOptions {
                dateFormat
                delimiter
                enclosure
                errorHandling
                header
                timeFormat
                timestampFormat
                whitespace
              }
              fileName
            }
            vendia {
              joinQuery
              keyColumns
              lastUpdatedColumn
              lastUpdatedColumnFormat
              tableName
            }
          }
          mapping {
            fieldId
            icebergFieldId
          }
        }
        status
      }
      nextToken
    }
  }
`
